<template>
<v-dialog v-model="dialog" max-width="800px">
	<v-card class="elevation-12">
		<v-toolbar
			color="primary"
			dark
			flat>
			<v-toolbar-title>{{ operation }} Course</v-toolbar-title>
		</v-toolbar>
		<v-card-text>
      <v-form
        ref="form"
        v-model="formValid"
        lazy-validation>
        <v-row>
          <v-col cols="12" md="8">
            <v-text-field
              autofocus
              prepend-icon="mdi-book"
              label="Title"
              v-model="item.title"
              placeholder="Ex. Visual Graphics Design NC III"
              :rules="[rules.required]"
              autocomplete="off"/>
          </v-col>

          <v-col cols="12" md="4">
            <v-text-field 
              v-model="item.shortTitle" 
              label="Short Title"
              placeholder="Ex. DIT, DHRT, DMET"
              prepend-icon="mdi-book"
              autocomplete="off"/>
          </v-col>

        </v-row>

        <v-row>
          <v-col cols="12" md="5">
            <v-text-field 
              v-model="item.subtitle" 
              label="Subtitle"
              placeholder="Ex. TWSP, SUP, UAQTEA"
              prepend-icon="mdi-book"
              autocomplete="off"/>
          </v-col>
          <v-col cols="12" md="7">
              <v-select
                prepend-icon="mdi-account"
                v-model="item.teacherId"
                :items="teachers"
                item-text="fullname"
                item-value="id"
                label="Trainer"
                :rules="[rules.required]">
              </v-select>
          </v-col>
        </v-row>
        
        <v-row>
          <v-col cols="12" md="3">
            <v-text-field 
              v-model="item.duration" 	
              prepend-icon="mdi-clock"
              label="Duration"
              placeholder="10 Days"
              :rules="[rules.required]"
              autocomplete="off"/>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field type="number"
              label="Slots"
              v-model="item.slots"
              prepend-icon="mdi-account"
              min="0"
              :rules="[rules.required]"
              autocomplete="off"/>
          </v-col>

          <v-col cols="12" md="3" class="d-flex justify-center">
            <v-switch
              v-model="item.hidden"
              label="Hidden">
            </v-switch>
          </v-col>
          <v-col cols="12" md="3" class="d-flex justify-center">
            <v-switch
              v-model="item.available"
              label="Available">
            </v-switch>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12" md="6" offset-md="3" class="d-flex justify-center">
            <v-text-field
              label="Remarks"
              v-model="item.remarks"
              prepend-icon="mdi-account"
              hint="Specify here why the course is unavailable"
              autocomplete="off"/>
          </v-col>
        </v-row>
      </v-form>
		</v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        @click="dialog = false">
        Close
      </v-btn>
      <v-btn v-if="(operation == FORM_STATUS.CREATE)"
        @click="resetFields()">
        Reset
      </v-btn>
      <v-btn 
        color="primary"
        @click="submit">
        {{ operation }}
      </v-btn>
    </v-card-actions>
	</v-card>
</v-dialog>
</template>

<script>
import { USER, FORM_STATUS } from '../../services/constants'
import Api from '../../services/api'
import Notify from '../../services/notify'
import FormRulesMixin from '../../mixins/form-rules.mixin'

export default {
  name: 'CourseForm',
  mixins: [ FormRulesMixin ],
  data() {
    return {
      FORM_STATUS,
      dialog: false,
      loading: false,
      operation: null,
      formValid: true,
      item: {},
      defaultItem: {
        teacherId: null,
        title: null,
        subtitle: null,
        duration: null,
        slots: 0,
        hidden: false,
        available: true,
        remarks: null,
      },
      teachers: [],
    }
  },
  mounted() {
    this.getTeachers();
  },
  methods: {
		resetFields() {
			this.item = Object.assign({}, this.defaultItem);
    },

    getTeachers() {
      function processTeachers(arr) {
        let teachers = [];
        arr.forEach(teacher => {
          if(teacher.type == USER.TEACHER) {
            teachers.push({
              id: teacher.id,
              fullname: teacher.lastname + ', ' + teacher.firstname
            });
          }
        });

        return teachers;
      }

      Api.user.getAllNames()
        .then((response) => {
          this.teachers = processTeachers(response.data);
        });
    },
    
    create(courseTypeId) {
      this.operation = FORM_STATUS.CREATE;
      this.dialog = true;
      this.resetFields();
      this.item.courseTypeId = courseTypeId;
    },

    update(courseId) {
      this.operation = FORM_STATUS.UPDATE;
      this.dialog = true;
      this.loading = true;
      Api.course.get(courseId)
        .then((response) => {
          this.item = response.data;
        });
    },

    delete(courseId) {
      this.operation = FORM_STATUS.DELETE;
      Notify.confirm('Delete course?', "Action can't be undone.")
        .then(() => {
          this.loading = true;
          Api.course.delete(courseId)
            .then(() => {
              this.dialog = false;
              Notify.success.itemDeleted();
              this.$emit('course-deleted');
            })
            .catch(() => { Notify.error.deleteFailed() })
            .finally(() => { this.loading = false });
        })
        .catch(() => {});
    },

    updateHidden(courseId, hidden) {
      Api.course.updateHidden({id: courseId, hidden})
        .then(() => {
          Notify.success.itemUpdated();
          this.$emit('course-updated');
        });
    },

    updateAvailable(courseId, available) {
      Api.course.updateAvailable({id: courseId, available})
        .then(() => {
          Notify.success.itemUpdated();
          this.$emit('course-updated');
        });
    },

    submit() {
			if(!this.$refs.form.validate()) {
        Notify.error.checkData();
        return;
      }

      if(this.operation == FORM_STATUS.CREATE) {
        this.loading = true;
        Api.course.create(this.item)
          .then(() => {
            this.dialog = false;
            Notify.success.itemCreated();
            this.$emit('course-created');
          })
          .catch(() => { Notify.error.createFailed() })
          .finally(() => { this.loading = false });
      }
      else if(this.operation == FORM_STATUS.UPDATE) {
        this.loading = true;
        Api.course.update(this.item)
          .then(() => {
            this.dialog = false;
            Notify.success.itemUpdated();
            this.$emit('course-updated');
          })
          .catch(() => { Notify.error.updateFailed() })
          .finally(() => { this.loading = false });
      }
    },
  },
}
</script>